<template>
  <div>

    <div v-if="!activeTrial.id" class="form">
      <validation-observer
          v-slot="{ handleSubmit }"
          ref="refFormObserver"
      >
        <b-form
            ref="form"
            @submit.stop.prevent="handleSubmit(createTrialLesson($event))"
            class="form validate"
        >
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="student"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите ученика')"
                  label-for="student"
              >
                <b-form-input
                    trim
                    name="student"
                    v-model="form.student"
                />
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="teacher"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите учителя')"
                  label-for="teacher"
              >
                <v-select
                    name="teacher_id"
                    :options="teachers"
                    label="name"
                    v-model="form.teacherId"
                    :reduce="model => model.id"
                >
                </v-select>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="status"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Статус')"
                  label-for="status"
              >
                <b-form-input
                    trim
                    name="status"
                    v-model="form.status"
                />
              </b-form-group>
            </validation-provider>
          </div>

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="date"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Выберите дату')"
                  label-for="date"
              >
                <flat-pickr
                    v-model="form.date"
                    class="form-control"
                    :config="{ enableTime: true,dateFormat: 'd.m.Y H:m',  time_24hr: true}"
                />
              </b-form-group>
            </validation-provider>
          </div>


          <b-button type="submit" variant="primary"> {{ $t('Создать пробный урок') }}</b-button>

        </b-form>
      </validation-observer>
    </div>
    <div v-else>
      <b-form
          ref="form"
          @submit.stop.prevent="editTrial"
          class="form validate"
      >
        <div class="mb-3">
        Ученик - {{ getModelName('students', activeTrial.student_id, 'name') }}
        </div>
        <div class="mb-3">
          Учитель - {{ getModelName('teachers', activeTrial.teacher_id, 'name') }}
        </div>
        <div class="mb-3">
          Статус - {{ getModelName('trialStatuses', activeTrial.trial_status_id, 'name') }}
        </div>

        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="status"
              :rules="{required: true}"
          >
            <b-form-group
                  :label="$t('Статус')"
                  label-for="status"
              >
                <b-form-input
                    trim
                    name="status"
                    v-model="activeTrial.status"
                />
              </b-form-group>
          </validation-provider>
        </div>

        <b-button class="mr-3" type="submit" variant="primary"> {{ $t('Редактировать пробный урок') }}</b-button>
        <b-button @click="closeEditing" type="reset"> {{ $t('Закрыть редактирование') }}</b-button>

      </b-form>
    </div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="trials"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
          slot="table-row"
          slot-scope="props"
      >

        <div
            v-if="props.column.field === 'teacher_id'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ getModelName('teachers', props.row.teacher_id, 'name') }}</span>
        </div>
        <!-- Column: Status -->

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="getTrial(props.row.id)">
                <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="removeTrial(props.row.id)">
                <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['3','5','10']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>

import {
  BAvatar,
  BBadge,
  BButton,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BPagination
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers} from 'vuex';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import moment from "moment";
import formattedDate from '@/mixins/formattedDate'
import CRMApi from '@/api/crm'

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('crm')

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormInvalidFeedback,
    BForm,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    flatPickr
  },
  mixins: [formattedDate],
  data() {
    return {
      pageLength: 3,
      dir: false,
      columns: [
        {
          label: 'Ученик',
          field: 'student',
        },
        {
          label: 'Учитель',
          field: 'teacher_id',
        },
        {
          label: 'Дата',
          field: 'date',
        },
        {
          label: 'Статус',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      form: {
        student: '',
        teacherId: '',
        status: '',
        date: '',
      },
      activeTrial: {}
    }
  },
  computed: {
    ...mapState({
      trialStatuses: state => state.trialStatuses,
      teachers: state => state.teachers,
      students: state => state.students,
      trials: state => state.trials
    })
  },
  methods: {
    ...mapActions(['getTrials', 'createTrial', 'getUsers']),
    ...mapMutations(['UPDATE_TRIAL']),
    createTrialLesson() {
      let trialData = {
        student: this.form.student,
        teacher_id: this.form.teacherId,
        status: this.form.status,
        date: moment(this.form.date, 'DD.MM.YYYY H:m').format('YYYY-MM-DD HH:mm'),
      }
      this.createTrial(trialData)
          .then(() => {
            this.form = {
              student: '',
              teacherId: '',
              status: '',
              date: '',
            }
            this.$bvToast.toast(this.$t('Пробный урок создан'), {
              title: this.$t('Вы создали пробный урок'),
              variant: 'success',
              solid: true,
            })
          })
          .catch(err => {
            this.$bvToast.toast(this.$t('Ошибка сервера, попробуйте позже'), {
              title: this.$t('Ошибка сервера, обратитесь к разработчику'),
              variant: 'danger',
              solid: true,
            })
          })

    },
    closeEditing() {
      this.activeTrial = {}
    },
    getTrial(id) {
      CRMApi.getTrial(id)
          .then(res => {
            this.activeTrial = res.data
          })
          .catch(err => {
            this.$bvToast.toast('Please try again later', {
              title: `Что-то пошло не так, попробуйте позже...`,
              variant: 'danger',
              solid: true,
            })
          })
    },
    editTrial() {
      CRMApi.updateTrial({
        id: this.activeTrial.id,
        status: this.activeTrial.status
      })
          .then(res => {
            this.$bvToast.toast('Вы успешно отредактировали статус урока', {
              title: `Успех! Отредактировано!`,
              variant: 'success',
              solid: true,
            })
            this.UPDATE_TRIAL(res.data);
            this.activeTrial = {}
          })
          .catch(err => {
            this.$bvToast.toast('Please try again later', {
              title: `Что-то пошло не так, попробуйте позже...`,
              variant: 'danger',
              solid: true,
            })
          })
    },
    removeTrial(id) {
      CRMApi.removeTrial(id)
          .then(res => {
            this.getTrials();
            this.$bvToast.toast('Пробный урок успешно удален', {
              title: `Вы удалили пробный урок`,
              variant: 'success',
              solid: true,
            })
          })
          .catch(err => {
            this.$bvToast.toast('Please try again later', {
              title: `Что-то пошло не так, попробуйте позже...`,
              variant: 'danger',
              solid: true,
            })
          })
    }
  },
  created() {
    this.getTrials();
    this.getUsers();
  }
}
</script>

<style scoped>

</style>
